import { useTranslation } from "react-i18next";
import { Link, Stack, SvgIcon, Typography } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useSharedErrorStyles } from "../sharedErrorStyles";
import { useStyle } from "./style";
import { useDeviceType } from "@hooks/useDeviceType";
import WarningIcon from "@static/icons/Warning.svg";
import RetryIcon from "@static/icons/Retry.svg";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IBroadbandQaFailedContentProps {
    onRetry?: () => void;
    onRemove?: () => void;
}

export const BroadbandQaFailedContent = (props: IBroadbandQaFailedContentProps) => {
    const { onRetry, onRemove } = props;
    const { t } = useTranslation("cart");
    const { isMobile } = useDeviceType();
    const { classes: sharedErrorClasses } = useSharedErrorStyles({ isMobile });
    const { classes } = useStyle({ isMobile });

    return (
        <Stack spacing={2}>
            <div className={sharedErrorClasses.titleContainer}>
                <SvgIcon className={sharedErrorClasses.warningIcon} component={WarningIcon} inheritViewBox />
                <Typography className={sharedErrorClasses.errorTitle} variant="large">
                    {t("broadband.qaFailed.title")}
                </Typography>
            </div>
            <Typography className={sharedErrorClasses.errorMessage} variant="normal">
                {t("broadband.qaFailed.message")}
            </Typography>
            {onRetry && (
                <div className={sharedErrorClasses.retryContainer}>
                    <div className={`${sharedErrorClasses.retryIconContainer} ${classes.retryIconContainer}`}>
                        <SvgIcon className={sharedErrorClasses.retryIcon} component={RetryIcon} inheritViewBox />
                        <Typography className={sharedErrorClasses.retryMessage} variant="small">
                            {t("broadband.qaFailed.retryMessage")}
                        </Typography>
                    </div>
                    <Link
                        className={`${sharedErrorClasses.retryLink} ${classes.retryLink}`}
                        variant="small"
                        onClick={onRetry}
                    >
                        {t("broadband.qaFailed.retry")}
                    </Link>
                </div>
            )}
            {onRemove && (
                <div className={sharedErrorClasses.removeButtonContainer}>
                    <LabeledButton labelText={t("broadband.remove")} startIcon={<DeleteIcon />} onClick={onRemove}>
                        {t("broadband.remove")}
                    </LabeledButton>
                </div>
            )}
        </Stack>
    );
};
